import Authorization from "../../generics/authorization";
import TabNavigation from "../../common/TabNavigation";
import { getCookie } from "../../serviceWorker";
import SubmenuHeaderView from "../insights/SubmenuHeaderView";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

// Constants
const LAYOUT_CONSTANTS = {
  X_VALUE: 0,
  W_VALUE: 12,
  HEADER_HEIGHT: 4,
  TAB_HEIGHT: 4,
  FILTER_HEIGHT: 2,
  FILTER_Y_POSITION: 10,
};

const UI_CONVERGENCE_COOKIE = "cl-analytics";

const createConvergenceHeader = () => ({
  filterDashlets: [
    {
      component: SubmenuHeaderView,
      name: "predictive-header",
      layout: {
        x: LAYOUT_CONSTANTS.X_VALUE,
        y: 0,
        w: LAYOUT_CONSTANTS.W_VALUE,
        h: LAYOUT_CONSTANTS.HEADER_HEIGHT,
      },
    },
  ],
});

const createLegacyHeader = () => ({
  filterDashlets: [
    {
      component: TabNavigation,
      name: "tab-nav-insights",
      layout: {
        x: LAYOUT_CONSTANTS.X_VALUE,
        y: 0,
        w: LAYOUT_CONSTANTS.W_VALUE,
        h: LAYOUT_CONSTANTS.TAB_HEIGHT,
      },
      style: { zIndex: 1 },
    },
  ],
});

// Main configuration
const getPageHeader = () => {
  const isUIConvergence = getCookie(UI_CONVERGENCE_COOKIE);
  return isUIConvergence ? createConvergenceHeader() : createLegacyHeader();
};

const createPageProps = () => ({
  ...getPageHeader(),
  dashlets: [],
  checkPageAccess: false,
  componentId: MFE_COMPONENT_IDS.THREAT_INTELLIGENCE,
});

// Component
const SecurityPage = () => <Authorization pageProps={createPageProps()} />;

export default SecurityPage;
